export default {
  title: 'Skatteoplysninger',
  buttons: {
    save: 'Gem',
  },
  toasts: {
    success: 'Dine oplysninger er gemt.',
  },
};
